import * as React from 'react';
import { Container } from 'reactstrap';
import ApolloThemeProvider from 'apollo-react/utils/ApolloThemeProvider';

export default class Layout extends React.PureComponent<{}, { children?: React.ReactNode }> {
    public render() {

        return (
            <ApolloThemeProvider>
                <Container>
                    {this.props.children}
                </Container>
            </ApolloThemeProvider>
        );
    }
}